import React from 'react';
import {StyleSheet, Text, View} from "react-native";
import OpenUrlButton from "./OpenUrlButton";
import {connect} from "react-redux";


class RichText extends React.Component{
    constructor(props) {
        super(props);
    }


    // extract urls and wrap them into <a/> components
    // opts: specify what to extract
    // (if key a is false => no a is extracted: to avoid links embedded in links)
    processText(txt, opts){
        const styles = StyleSheet.create({
            text : {
                display: 'inline',
                width: 'fit-content',
                fontFamily:this.props.theme.fonts.text,
                color:this.props.theme.colors.tertiary.black1.value,
            }
        })
        const url_pattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/

        const elems = txt.split(url_pattern).map((x, i) => {
              if (opts.a && x.match(url_pattern)) {
                let url = x;
                // an url without http(s) will be interpreted as local to this site
                // Don't, except if this is current site: prefix w/ https
                if (!x.startsWith("http") && !x.startsWith(window.location.hostname)) {
                  url = "https://" + url;
                }
                return <OpenUrlButton key={i} url={url} title={x} />
            } else {
                return <Text style={styles.text} key={i}>{ x }</Text>
            }
        })
        return <View style={{display:'block',whiteSpace:'pre-wrap'}}>{ elems }</View>;
    }

    // transform a string into react components
    toRichText(txt, opts = {}){
        opts = {a: true, ...opts};

        return <View>
            { this.processText(txt || "", opts) }
        </View>

    }

    render() {
        return <View>{this.toRichText(this.props.text)}</View>;
    }
}


const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(RichText);
